import appTheme from "../appTheme"

/**
 * Extends the global app theme with article-specific theme for the article pages.
 */
const articleThemeExtension = (category) => ({
  ...appTheme,
  article: {
    color: appTheme.colors.categories[category.toLowerCase()],
  },
})

export default articleThemeExtension
